export default __webpack_public_path__ + "static/_MG_1300-22004883a3b2ec59cc8a803f4698acc9.jpg";